import {
  IsNumber,
  IsOptional,
  IsString,
  ValidateNested,
} from 'class-validator';
import { PaymentDonationDto } from '@up/data';

export class FireOpenPaymentRequestDto {
  @IsNumber()
  amount: number;

  @IsString()
  description: string;

  @IsNumber()
  merchantId: number;

  @IsOptional()
  @IsString()
  currency?: string;

  @IsOptional()
  @IsString()
  myRef?: string;

  @IsOptional()
  @IsString()
  returnUrl?: string;

  @IsOptional()
  @ValidateNested({ each: true })
  donations?: PaymentDonationDto[] | null;

  @IsOptional()
  @IsNumber()
  paymentMethodId?: number;

  @IsOptional()
  @IsNumber()
  customerId?: number;

  @IsOptional()
  @IsString()
  notificationUrl?: string;

  @IsOptional()
  notificationData?: any;
}
